import { FormControl, FormLabel, TextField, useMediaQuery, useTheme } from '@mui/material';

type Props = {
  label?: string;
  value: number;
  required?: boolean;
  disabled?: boolean;
  autoFocus?: boolean;
  error: string;
  min?: number;
  max?: number;
  step?: number;
  fullWidth?: boolean;
  onChange: (value: number) => void;
};

const NumberField = ({
  label,
  value,
  required,
  disabled,
  autoFocus,
  error,
  min,
  max,
  step,
  fullWidth = true,
  onChange,
}: Props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const actualFullWidth = isMobile ? true : fullWidth;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const parsedValue = step === 1 ? parseInt(event.target.value) : parseFloat(event.target.value);
    onChange(parsedValue);
  };

  return (
    <FormControl variant="standard" fullWidth={actualFullWidth}>
      {label && <FormLabel required={required}>{label}</FormLabel>}
      <TextField
        sx={{ marginTop: '0' }}
        type="number"
        value={`${value}`}
        label={''}
        fullWidth={actualFullWidth}
        margin="dense"
        required={required}
        size="small"
        inputProps={{ min, max, step }}
        disabled={disabled}
        error={error !== undefined}
        onChange={handleChange}
        helperText={error}
        autoFocus={autoFocus}
      />
    </FormControl>
  );
};

export default NumberField;
